import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL!;

declare global {
  interface Window {
    snap: any;
    fbq: any;
  }
}

const PaymentReceiptPage = () => {
  const { donationId } = useParams();
  const [data, setData] = useState<any>(null);
  const checkoutSent = useRef(false);

  useEffect(() => {
    const fetchDonation = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/donations/${donationId}`);
        setData(res.data.donation);
      } catch (err) {
        console.error(err);
      }
    };

    fetchDonation();
  }, [donationId]);

  useEffect(() => {
    if (data && window.fbq && !checkoutSent.current) {
      window.fbq("track", "InitiateCheckout", {
        value: Number(data.amount),
        currency: "IDR",
        content_ids: [data.id],
        content_type: "donation",
      });

      checkoutSent.current = true;
    }
  }, [data]);

  const handlePayment = () => {
    if (!data?.snap_token) {
      alert("Snap token tidak tersedia");
      return;
    }

    // ✅ INITIATE CHECKOUT
    // if (window.fbq) {
    //   window.fbq("track", "InitiateCheckout", {
    //     value: Number(data.amount),
    //     currency: "IDR",
    //     content_ids: [data.id],
    //     content_type: "product",
    //   });
    // }

    window.snap.pay(data.snap_token, {
      onSuccess: function (result: any) {
        if (window.fbq) {
          window.fbq("track", "Purchase", {
            value: Number(data.amount),
            currency: "IDR",
            content_ids: [data.id],
            content_type: "donation",
            transaction_id: result.transaction_id,
          });
        }

        setTimeout(() => {
          window.location.reload();
        }, 800);
      },

      onPending: function () {
        alert("Menunggu pembayaran...");
      },

      onError: function () {
        alert("Pembayaran gagal");
      },

      onClose: function () {
        console.log("Popup ditutup");
      },
    });
  };

  if (!data) return <div className="p-5"></div>;

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-6 font-signika">
      <div className="relative w-full max-w-xl bg-white rounded-3xl shadow-2xl overflow-hidden">
        {/* STRIP GRADIENT ATAS */}
        <div className="h-2 bg-gradient-to-r from-[#29abe2] via-[#1f8ac0] to-[#8cc63f]" />

        <div className="p-8">
          {/* HEADER */}
          <div className="text-center">
            {/* <div
              className="w-20 h-20 mx-auto mb-4 rounded-full 
                            bg-[#29abe2]/20 
                            flex items-center justify-center">
              <span className="text-3xl">💙</span>
            </div> */}

            <div className="flex justify-center mb-4">
              <img src="/images/logo.png" alt="" className="w-32 h-12" />
            </div>

            <h2 className="text-2xl font-semibold">Konfirmasi Donasi</h2>
            <p className="text-gray-500 text-sm mt-1">Silakan periksa detail di bawah ini</p>
          </div>

          {/* DETAIL */}
          <div className="mt-10 space-y-6 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-500">Donatur</span>
              <span className="font-medium">{data.name}</span>
            </div>

            <div className="flex justify-between">
              <span className="text-gray-500">Email</span>
              <span>{data.email || "-"}</span>
            </div>

            <div className="flex justify-between">
              <span className="text-gray-500">WhatsApp</span>
              <span>{data.phone || "-"}</span>
            </div>
          </div>

          {/* DIVIDER */}
          <div className="my-8 border-t border-dashed border-gray-300"></div>

          {/* TOTAL SECTION */}
          <div className="flex justify-between items-center">
            <div>
              <p className="text-gray-500 text-sm">Total Donasi</p>

              {/* NOMINAL dengan neon */}
              <p
                className="text-2xl font-bold text-primary2
                            drop-shadow-[0_0_10px_rgba(41,171,226,0.6)]">
                Rp {Number(data.amount).toLocaleString("id-ID")}
              </p>
            </div>

            {data.status === "paid" && <div className="text-green-500 text-2xl">✔</div>}
          </div>

          {/* BUTTON */}
          {data.status === "pending" && (
            <button
              onClick={handlePayment}
              className="mt-8 w-full py-4 rounded-2xl text-white font-semibold 
                         bg-gradient-to-r from-[#29abe2] to-[#1f8ac0]
                         shadow-[0_0_25px_rgba(41,171,226,0.6)]
                         hover:shadow-[0_0_35px_rgba(41,171,226,0.9)]
                         transition-all duration-300">
              Bayar Sekarang →
            </button>
          )}

          {/* FOOTER */}
          <p className="text-center text-xs text-gray-400 mt-6">Didukung oleh Midtrans Payment Gateway</p>
        </div>
      </div>
    </div>
  );
};

export default PaymentReceiptPage;
